import * as ActionConstants from "../constants/ReduxConstants";

const initialState = {
  data: null,
  error: null,
  isLoading: false,
};

export const fileUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionConstants.FILE_UPLOAD_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ActionConstants.FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null,
      };
    case ActionConstants.FILE_UPLOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
};
